import { createMongoAbility } from "@casl/ability";
import React, { Suspense, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import { WordPressAppContext } from ".";
import "../../assets/css/vendor/bootstrap.min.css";
import BillingProvider from "../app/BillingProvider";
import { AbilityContext } from "/@src/components/Can";
import { NotificationContainer } from "/@src/components/common/react-notifications";
import CustomModal from "/@src/components/newComponents/CustomModal";
import AppLocale from "/@src/lang";
import AppLayoutLoading from "/@src/layout/AppLayoutLoading";
import { store } from "/@src/redux/store";
import MediaProvider from "./MediaProvider";

const WordPressApp = React.lazy(() => import("./app"));

const WordPressEmbedded = ({
  clientId: projectId,
  apiKey,
  page: initialPage,
}) => {
  const locale = "en";
  const currentAppLocale = AppLocale[locale];
  const slug = window.location.hostname;

  useEffect(() => {
    if (!document.getElementById("bitbute-ar-viewer-script")) {
      const bitbuteScript = document.createElement("script");
      bitbuteScript.setAttribute("type", "module");
      bitbuteScript.setAttribute("id", "bitbute-ar-viewer-script");
      bitbuteScript.setAttribute("async", "");
      bitbuteScript.setAttribute("defer", "");
      bitbuteScript.setAttribute("src", import.meta.env.VITE_VIEWER_SCRIPT_URL);
      document.body.appendChild(bitbuteScript);
    }
    import(`../../assets/css/sass/themes/gogo.light.purplemonster.scss`);
  }, []);

  const [page, setPage] = useState("dashboard");

  const [resourceId, setResourceId] = useState("root");

  const [ability] = useState(createMongoAbility([]));

  return (
    <Provider store={store}>
      <div className="h-100" id="wordpress-embedded">
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
          onError={(e) => {
            console.log(e);
          }}
        >
          <AbilityContext.Provider value={ability}>
            <BillingProvider>
              <MediaProvider>
                <NotificationContainer />
                <div id="modal-root" />
                {/* {isMultiColorActive && <ColorSwitcher />} */}
                <Suspense fallback={<AppLayoutLoading />}>
                  <CustomModal container="#modal-root" />
                  <WordPressAppContext.Provider
                    value={{
                      initialPage,
                      page: page,
                      slug,
                      projectId,
                      apiKey,
                      setPage,
                      resourceId,
                      setResourceId,
                    }}
                  >
                    <WordPressApp />
                  </WordPressAppContext.Provider>
                </Suspense>
              </MediaProvider>
            </BillingProvider>
          </AbilityContext.Provider>
        </IntlProvider>
      </div>
    </Provider>
  );
};

export default WordPressEmbedded;
